import styled from "styled-components";
import {
  colors,
  fontSizes, 
  fontWeights, 
  spacings,
  borders
} from 'styles/theme';

export const Container = styled.div`
`

export const TableSearchUsers = styled.div`
  display: flex;
  width: 50%;
  
  button{
    margin-left: ${fontSizes.xl};
  }
`

export const ContainerTable = styled.div`
  border: ${borders.xs} solid ${colors.neutral_regular};
  border-radius: ${borders.sm};
  overflow: hidden;

  span{
    /* margin-right: ${spacings.md}; */
    font-weight: ${fontWeights.w700};
    font-size: ${fontSizes.sl};
    color: ${colors.neutral_darkest};
  }
`

export const ContainerLoading = styled.div`
  padding: ${spacings.lg} 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  button {
    margin-top: ${spacings.md};
    width: auto;
    height: 45px;
  }

  /* ENDLESS ROTATE */
  .rotate{
    animation: rotate 3.5s linear infinite; 
  }
  @keyframes rotate{
    to{ transform: rotate(360deg); }
  }


  /* SPINNER JUST FOR DEMO */
  .spinner{
    display:inline-block; 
    width: 70px; 
    height: 70px;
    border-radius: 50%;
    border: ${borders.sm} dashed ${colors.primary_click};
    border-spacing: 100px;
  }
`

export const TableContent = styled.table`
  border-collapse: collapse!important;
  width: 100%;

  thead{
    background: ${colors.neutral_light};
    tr{
      th{
        min-width: ${spacings.ls};
        height: 48px;
        padding-left: ${spacings.md};
        text-align: left;

        button{
          display: flex;
          align-items: center;
          width: 100%;
          text-align: left;
          border: none;
          font-weight: ${fontWeights.w700};
          font-size: ${fontSizes.sl};
          color: ${colors.neutral_darkest};
          background-color: transparent;

          svg{
            margin-left: ${spacings.sl};
          }
        }

        input{
          margin-top: ${spacings.sl};
          border: ${borders.xs} solid  #${colors.neutral_medium};
          outline: none;
          width: 100%;
          padding: ${spacings.xs};
          color: ${colors.neutral_darkest};
          font-weight: ${fontWeights.w500};
          font-size: ${fontSizes.sm};
          background: ${colors.white};
          border-radius: ${borders.md};
        }
        
      }
    }
  }

  tbody{

    tr{
      background: ${colors.neutral_light};

      td{
        height: 56px;
        padding-left: ${spacings.md};
        text-align: left;
        font-weight: ${fontWeights.w500};
        font-size: ${fontSizes.sm};
        color: ${colors.neutral_darkest};
      }

      &:nth-child(2n+1){
        background: ${colors.white};
      }
    }
  }
`